<script>
import Vue from 'vue';
import {required, sameAs} from 'vuelidate/lib/validators'
import {validatePassword} from '../../services/ValidatorService'
import {mapState, mapActions} from 'vuex';
import PreloaderItem from '../PreloaderItem/PreloaderItem.vue';
import SelectLanguage from '../SelectLanguage/SelectLanguage.vue';

export default Vue.extend({
    components: {
        PreloaderItem,
        SelectLanguage
    },
    data () {
        return {
            pass: undefined,
            passCheck: undefined,
            timer: 5,
            interval: undefined,
            submitted: false
        }
    },
    validations() {
        return {
            pass: {
                required,
                validatePassword: (password) => {
                    return validatePassword(password).valid;
                }
            },
            passCheck: {
                required,
                validatePassword: (password) => {
                    return validatePassword(password).valid;
                },
                sameAsPassword: sameAs('pass')
            }
        }
    },
    computed: {
        ...mapState({
            loading: state => state.auth.activation.loading,
            message: state => state.auth.activation.message
        }),
        passClasses () {
            return {
                'activate-user-page__input--error': this.$v.pass.$dirty && this.$v.pass.$error,
                'activate-user-page__input--success': this.$v.pass.$dirty && !this.$v.pass.$error
            }
        },
        passCheckClasses () {
            return {
                'activate-user-page__input--error': this.$v.passCheck.$dirty && this.$v.passCheck.$error,
                'activate-user-page__input--success': this.$v.passCheck.$dirty && !this.$v.passCheck.$error
            }
        }
    },
    methods: {
        ...mapActions({
            activate: 'auth/activate'
        }),
        submit () {
            this.$v.$touch();
            // If input validation passes then submit request
            if (!this.$v.pass.$error && !this.$v.passCheck.$error) {
                this.activate({
                    pass: this.pass,
                    token: this.$route.params.token
                }).then(() =>{
                    // If activation was successful then redirect to login page
                    if(this.message.level === 'success') {
                        this.submitted = true;
                        this.interval = setInterval(() => {
                            this.timer = this.timer - 1;
                            if (this.timer === 0) {
                                clearInterval(this.interval);
                                this.$router.push('/');
                            }
                        }, 1000);
                    }
                });
            }
        }
    }
});
</script>
<template>
    <div class="activate-user-page">
        <div class="activate-user-page__heading">{{ $t('activateUser.heading') }}</div>
        <div class="activate-user-page__paragraph">{{ $t('activateUser.description') }}</div>
        <div v-if="message" :class="`activate-user-page__alert--${message.level}`">
            {{ $t(message.text) }}
            <span v-if="message.level === 'success'">{{ timer }}</span>
        </div>
        <div class="activate-user-page__form">
            <div class="activate-user-page__input-group">
                <input :placeholder="$t('activateUser.pass.placeholder')"
                       v-model="pass"
                       :class="passClasses"
                       type="password"
                       class="activate-user-page__input"
                       @input="$v.pass.$touch()"
                       @keyup.enter="submit">
                <div v-if="$v.pass.$dirty && !$v.pass.required" class="activate-user-page__input-help">{{ $t('activateUser.pass.errors.required') }}</div>
                <div v-if="$v.pass.$dirty && !$v.pass.validatePassword" class="activate-user-page__input-help">{{ $t('account.password.validator.password') }}</div>
            </div>
            <div class="activate-user-page__input-group">
                <input :placeholder="$t('activateUser.passCheck.placeholder')"
                       v-model="passCheck"
                       :class="passCheckClasses"
                       type="password"
                       class="activate-user-page__input"
                       @input="$v.passCheck.$touch()"
                       @keyup.enter="submit">
                <span v-if="$v.passCheck.$dirty && !$v.passCheck.sameAsPassword" class="activate-user-page__input-help" >{{ $t('activateUser.passCheck.errors.mismatch') }}</span>
                <span v-if="$v.passCheck.$dirty && !$v.passCheck.required" class="activate-user-page__input-help">{{ $t('activateUser.passCheck.errors.required') }}</span>
            </div>
            <div class="activate-user-page__input-group">
                <button :disabled="loading || submitted" class="activate-user-page__submit" @click="submit">
                    <span v-if="!loading">{{ $t('activateUser.button') }}</span>
                    <preloader-item v-if="loading"/>
                </button>
            </div>
            <select-language/>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ActivateUserPage/ActivateUserPage.vue